import React from "react";
import { MusicPracticeRoomDetailContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { withTranslation } from "react-i18next";
import { userService } from "apiServices";
import { IMG_PATH } from "utils/constants/imgPath";
import { ROUTE_PATH } from "utils/constants/routePath";
import { Headers, Displays, Buttons, Icons, Navigations } from "components";

class MusicPracticeRoomDetailContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    const { router } = this.props;
    let res = await userService.GET_ROOM_DETAIL(router.params.id);
    if (res && res.status === 200) {
      this.setState({
        data: res.data,
        isLoading: false,
      });
    }
  };

  handleClickBooking = () => {
    const { data } = this.state;
    // เลือกห้องจากหน้ารายละเอียดแล้ว ข้าม step 1 แต่ต้องผ่านขั้นข้อมูลติดต่อก่อนเลือกวัน/เวลา
    this.props.router.navigate(
      `${ROUTE_PATH.MUSIC_PRACTICE_ROOM}/${data._id}/booking/contact?room_ref_id=${data._id}`,
    );
  };

  handleGoBack = () => {
    this.props.router.navigate(ROUTE_PATH.MUSIC_PRACTICE_ROOM);
  };
  render() {
    const { i18n, t } = this.props;
    const { isLoading, data } = this.state;
    const DATE_BREADCRUMB = [
      {
        name: t("Home", { ns: "common" }),
        path: ROUTE_PATH.HOME,
      },
      {
        name: t("Music Practice Room", { ns: "common" }),
        path: `${ROUTE_PATH.MUSIC_PRACTICE_ROOM}`,
      },
    ];
    return (
      <MusicPracticeRoomDetailContainerStyled>
        <div className="breadcrumb_layout">
          <Navigations.Breadcrumb data={DATE_BREADCRUMB} />
        </div>
        <div className="music_practice_container">
          <div className="header_layout">
            <Headers.NewPageHeader
              title={"MUSIC PRACTICE ROOM"}
              sub_title={"ห้องซ้อมดนตรี"}
            />
          </div>
          {isLoading ? (
            <Displays.Loading />
          ) : (
            <>
              <div className="topic_block">
                <div className="title">
                  {i18n.language === "en" ? data.name_en : data.name_th}
                </div>
                <div className="price">
                  ({data.pricing.hourly_rate} THB/Hour )
                </div>
              </div>
              <div className="banner_block">
                {data.gallery_imgs &&
                  data.gallery_imgs.length > 0 &&
                  data.gallery_imgs.map((img, index) => (
                    <div key={index} className="banner_img_wrap">
                      <Displays.ImageSmooth
                        key={index}
                        className="banner_img"
                        alt="banner"
                        src={IMG_PATH + img.path}
                      />
                    </div>
                  ))}
              </div>
              <div className="description">
                {i18n.language === "en"
                  ? data.description_en
                  : data.description_th}
              </div>
              <div className="feature_block">
                {data.room_size && (
                  <div className="feature_item">
                    <Icons.MprRoomSize />
                    <div className="feature_item_text">
                      Room Size : {data.room_size}m²
                    </div>
                  </div>
                )}
                {data.no_smoking && (
                  <div className="feature_item">
                    <Icons.MprNoSmoking />
                    <div className="feature_item_text">Non-smoking</div>
                  </div>
                )}
                {data.free_parking && (
                  <div className="feature_item">
                    <Icons.MprFreeParking />
                    <div className="feature_item_text">Free Parking</div>
                  </div>
                )}
                {data.free_wifi && (
                  <div className="feature_item">
                    <Icons.MprFreeWiFi />
                    <div className="feature_item_text">Free WiFi</div>
                  </div>
                )}
              </div>
              <div className="book_block">
                <div className="btn_book_wrap">
                  <Buttons.BgStandard
                    height={"40px"}
                    label={t("BOOK NOW", { ns: "common" })}
                    onClick={this.handleClickBooking}
                  />
                </div>
              </div>
              <div className="button_layout">
                <div className="button1">
                  <Buttons.BgStandard
                    theme_white_purple
                    label={t("Back", { ns: "common" })}
                    onClick={this.handleGoBack}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </MusicPracticeRoomDetailContainerStyled>
    );
  }
}

export default withTranslation(["common", "news"])(
  withRouter(MusicPracticeRoomDetailContainer),
);
